import React from 'react';
import Icon from '../Icon/Icon';
import styles from './StudentNotesModalHeader.module.css';

interface StudentNotesModalHeaderProps {
  title?: string;
  closeLabel?: string;
  loading?: boolean;
  onClose: () => void;
}

const StudentNotesModalHeader: React.FC<StudentNotesModalHeaderProps> = ({
  title = 'Observações',
  closeLabel = 'Fechar observações',
  loading = false,
  onClose,
}) => (
  <header className={styles.header}>
    <h3 id="student-notes-modal-title" className={styles.title}>
      {title}
    </h3>
    <button
      type="button"
      className={styles.closeButton}
      onClick={onClose}
      aria-label={closeLabel}
      disabled={loading}
    >
      <Icon name="close" size={22} />
    </button>
  </header>
);

export default StudentNotesModalHeader;
